import React from 'react';
import FormSaveNotifier from 'formSaveNotifier/components/FormSaveNotifier';
import { useFormContext } from 'react-hook-form';
const NavWarning = (props) => {
    const { formState } = useFormContext();
    return <FormSaveNotifier when={formState.isDirty && !formState.isSubmitted && !formState.isSubmitting} />;
};
export default NavWarning;
